import { AppBundle } from 'api/optimalprint-sdk.d';

export interface SelectedOptions {
  typeName: string;
  values: string[];
}

export interface QueryFilters {
  attributeFilters: SelectedOptions[];
  tagFilters: SelectedOptions[];
}

const extractCurrentSelectedOptions = (
  filter: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem[],
) =>
  filter.reduce((result, filterProperty) => {
    const minimizedFilter = {
      typeName: filterProperty.typeName,
      values: filterProperty.options?.filter((option) => option.isSelected).map((option) => option.value) || [],
    };
    if (minimizedFilter.values.length) {
      result.push(minimizedFilter);
    }
    return result;
  }, [] as SelectedOptions[]);

const prepareCategoryFilters = (filters?: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters) =>
  ({
    attributeFilters: filters ? extractCurrentSelectedOptions(filters.attributeFilters) : [],
    tagFilters: filters ? extractCurrentSelectedOptions(filters.tagFilters) : [],
  } as QueryFilters);

export default prepareCategoryFilters;
